export class SwalEx {
    static createMessage(icon, text) {
        if (icon && text)
            return `<div class="swal2-content-with-symbol"><i class="fal ${icon} fa-4x"></i><p>${text}</p></div>`;
        if (text)
            return `<div class="swal2-content">${text}</div>`;
        return ``;
    }
    static createButton(id, icon, text, cssClass, disabled) {
        return `<a id="${id}" class="icon-button ${cssClass ? cssClass : 'icon-button-user-action-base'} ${(disabled ? ' icon-button-disabled' : '')}">
			<i class="fa-4x ${icon}"></i>
			<div class="">${text}</div></a>`;
    }
    static createInput(id, errorMessage, maxlength, prefix) {
        if (!prefix)
            prefix = '';
        return `<div class="input-wrapper"><div>${prefix}</div><div><input id="${id}" ${(maxlength > 0 ? `maxlength="${maxlength}"` : '')}><div data-message="hidden">${errorMessage}</div></div></div>`;
    }
    static getDefaultSwalOptions(title, icon, message, htmlBetweenMessageAndButtons, buttonsIdBase, buttons) {
        let html = this.createMessage(icon, message);
        if (htmlBetweenMessageAndButtons)
            html += htmlBetweenMessageAndButtons;
        if (buttons && buttons.length > 0) {
            html += '<div class="swal-icon-buttons-wrapper">';
            for (var i = 0; i < buttons.length; i++) {
                if (buttons[i].ButtonText) {
                    if (buttonsIdBase == null) {
                        buttonsIdBase = '';
                    }
                    html += this.createButton((buttonsIdBase) + i, buttons[i].ButtonIcon, buttons[i].ButtonText, buttons[i].CssClass, false);
                }
            }
            html += '</div>';
        }
        let swalOptions = {
            title: title,
            html: html,
            showConfirmButton: false,
            showCancelButton: false,
            showCloseButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
                container: 'swal-custom-container',
            },
            showClass: {
                popup: 'animated animate__fadeInLeft'
            },
            hideClass: {
                popup: 'animated animate__fadeOutRight'
            }
        };
        return swalOptions;
    }
    static alertCustom(title, message, thenFunction, alertOnly, icon) {
        let buttons = [];
        let okButton = new SwalExButton();
        okButton.ButtonIcon = 'fal fa-square-check';
        okButton.ButtonText = SwalEx.okButtonText;
        if (thenFunction)
            okButton.Callback = () => { thenFunction(true); return null; };
        buttons.push(okButton);
        if (!alertOnly) {
            let cancelButton = new SwalExButton();
            cancelButton.ButtonIcon = 'fal fa-square-xmark';
            cancelButton.ButtonText = SwalEx.cancelButtonText;
            cancelButton.CssClass = 'icon-button-danger';
            if (thenFunction)
                cancelButton.Callback = () => { thenFunction(false); return null; };
            buttons.push(cancelButton);
        }
        let buttonIdPrefix = 'alertCustomButton';
        let swalOptions = SwalEx.getDefaultSwalOptions(title, icon, message, null, buttonIdPrefix, buttons);
        swalOptions.willOpen = () => {
            for (var j = 0; j < buttons.length; j++) {
                let button = buttons[j];
                $(`#${buttonIdPrefix}${j}`).on('click', () => {
                    Swal.close();
                    button.Callback();
                });
            }
        };
        Swal.fire(swalOptions);
    }
    static alertSuccessCustom(title, message) {
        Swal.fire(title, message, 'success');
    }
}
export class SwalExButton {
    constructor() {
        this.InitiallyHidden = false;
    }
}
window.SwalEx = SwalEx;
window.SwalExButton = SwalExButton;
